import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetVoucherIdByCode, GetVoucherIdByCodeResponse } from '../api/dtos';

const getData = (response?: SWRResponse<GetVoucherIdByCodeResponse, GetVoucherIdByCodeResponse>) => response?.data;
const getError = (response?: SWRResponse<GetVoucherIdByCodeResponse, GetVoucherIdByCodeResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useGetVoucherIdByCode = (code?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!code) {
            return undefined;
        }

        return () => {
            return new GetVoucherIdByCode({ code });
        };
    }, [code]);

    return useGet(request, { getData, getError }, configuration);
};

export default useGetVoucherIdByCode;
